import { Container, Heading } from '@chakra-ui/react';
import { useEffect, useState, useContext } from "react"
import DipendentiTable from "./DipendentiTable";
import AddDipendenteModal from "./AddDipendenteModal";
import AuthContext from '../../contexts/AuthContext';

import axios from 'axios'
import { useCompany } from '../../contexts/CompanyContext';

const PersonalePage = () => {
    const [dipendenti, setDipendenti] = useState([]);
    const {getToken} = useContext(AuthContext);
    const {selectedCompany} = useCompany();

    useEffect(() => {
        retrieveDipendenti();
    }, []);

    /**
     * Method to retrieve the list of dipendenti
     */
    function retrieveDipendenti() {
        axios.get(`/api/${selectedCompany['company_id']}/dipendenti`, {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                },
            }).then(response => {
                if(response.status === 200){
                    setDipendenti(response.data.dipendenti);
                }else{
                    console.error("Error fetching dipendenti: " + response.data);
                }
            }).catch((error) => {
                console.error("Error fetching dipendenti", error);
            });
    }

    return (
        <Container maxW="container.xl" py={8}>
            <Heading mb={4}>Dipendenti</Heading>
            <AddDipendenteModal retrieveDipendenti={retrieveDipendenti}></AddDipendenteModal>
            <DipendentiTable dipendenti={dipendenti} retrieveDipendenti={retrieveDipendenti}></DipendentiTable>
        </Container>
    )
}

export default PersonalePage;